import { updateShippingAddress } from 'api/user/customer_requests';
import Button from 'components/base/Button';
import { useState } from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { updateShippingAddress as updateShippingAddressAction } from 'redux-state/user/customerSlice';
import { updateBillingAddress } from 'api/user/customer_requests';
import { updateBillingAddress as updateBillingAddressAction } from 'redux-state/user/customerSlice';

const EcomVendorDetailAddressInfo = ({ vendorId }: { vendorId?: string }) => {
  const dispatch = useDispatch();
  const customerDetails = useSelector(
    (state: RootState) => state.user.customer
  );

  const [submitting, setSubmitting] = useState(false);
  const [street, setStreet] = useState(
    customerDetails?.shippingAddress?.street || ''
  );
  const [city, setCity] = useState(
    customerDetails?.shippingAddress?.city || ''
  );
  const [state, setState] = useState(
    customerDetails?.shippingAddress?.state || ''
  );
  const [country, setCountry] = useState(
    customerDetails?.shippingAddress?.country || ''
  );
  const [postalCode, setPostalCode] = useState(
    customerDetails?.shippingAddress?.postalCode || ''
  );
  const [phone, setPhone] = useState(
    customerDetails?.shippingAddress?.phone || ''
  );

  // Billing address states
  const [billingStreet, setBillingStreet] = useState(
    customerDetails?.billingAddress?.street || ''
  );
  const [billingCity, setBillingCity] = useState(
    customerDetails?.billingAddress?.city || ''
  );
  const [billingState, setBillingState] = useState(
    customerDetails?.billingAddress?.state || ''
  );
  const [billingCountry, setBillingCountry] = useState(
    customerDetails?.billingAddress?.country || ''
  );
  const [billingPostalCode, setBillingPostalCode] = useState(
    customerDetails?.billingAddress?.postalCode || ''
  );
  const [billingPhone, setBillingPhone] = useState(
    customerDetails?.billingAddress?.phone || ''
  );

  const handleUpdateShippingAddress = async () => {
    setSubmitting(true);
    const profile = {
      street,
      city,
      state,
      country,
      postalCode,
      phone
    };

    await updateShippingAddress(profile).then(res => {
      toast.success('Shipping address updated successfully');
      dispatch(updateShippingAddressAction(profile));
      setSubmitting(false);
    });
  };

  const handleUpdateBillingAddress = async () => {
    setSubmitting(true);
    const profile = {
      street: billingStreet,
      city: billingCity,
      state: billingState,
      country: billingCountry,
      postalCode: billingPostalCode,
      phone: billingPhone
    };

    await updateBillingAddress(profile).then(res => {
      toast.success('Billing address updated successfully');
      dispatch(updateBillingAddressAction(profile));
      setSubmitting(false);
    });
  };

  return (
    <div>
      <Accordion>
        <Accordion.Item eventKey="0" className="border-top">
          <Accordion.Header>
            <h3 className="">Shipping Address</h3>
          </Accordion.Header>
          <Accordion.Body>
            <Row className="justify-content-between gy-6 gx-5">
              <Col lg={12}>
                <Row className="g-4">
                  <Col xs={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Street
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Street"
                        value={street}
                        onChange={e => setStreet(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        City
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="City"
                        value={city}
                        onChange={e => setCity(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        State
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="State"
                        value={state}
                        onChange={e => setState(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Country
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Country"
                        value={country}
                        onChange={e => setCountry(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Postal Code
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Postal Code"
                        value={postalCode}
                        onChange={e => setPostalCode(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Phone
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Phone"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} className="text-end">
                <Button
                  type="submit"
                  variant="primary"
                  className="px-7"
                  disabled={submitting}
                  onClick={handleUpdateShippingAddress}
                >
                  {submitting ? 'Saving...' : 'Save changes'}
                </Button>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1" className="border-top">
          <Accordion.Header>
            <h3 className="">Billing Address</h3>
          </Accordion.Header>
          <Accordion.Body>
            <Row className="justify-content-between gy-6 gx-5">
              <Col lg={12}>
                <Row className="g-4">
                  <Col xs={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Street
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Street"
                        value={billingStreet}
                        onChange={e => setBillingStreet(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        City
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="City"
                        value={billingCity}
                        onChange={e => setBillingCity(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        State
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="State"
                        value={billingState}
                        onChange={e => setBillingState(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Country
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Country"
                        value={billingCountry}
                        onChange={e => setBillingCountry(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Postal Code
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Postal Code"
                        value={billingPostalCode}
                        onChange={e => setBillingPostalCode(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                        Phone
                      </label>
                      <Form.Control
                        type="text"
                        placeholder="Phone"
                        value={billingPhone}
                        onChange={e => setBillingPhone(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} className="text-end">
                <Button
                  type="submit"
                  variant="primary"
                  className="px-7"
                  disabled={submitting}
                  onClick={handleUpdateBillingAddress}
                >
                  {submitting ? 'Saving...' : 'Save changes'}
                </Button>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default EcomVendorDetailAddressInfo;
